import Map from "./Map";
import Address from "./Address";
import Form from "./Form";
import Newsletter from "../Homecomponents/Newsletter";

const Maincontact = () => {
  return (
    <>
      <Map />
      <Address />
      <Form />
      <Newsletter />
    </>
  );
};

export default Maincontact;
